class CompositionBlockTableSelect extends HTMLElement {
	constructor() {
		super();

		this.triggers = this.querySelectorAll('[data-custom-select-toggle], input[type=radio]+label');
		this.options = this.querySelectorAll('[data-custom-select-option]');
		this.optionSelected = this.querySelector('[data-custom-select-option-selected]');
		this.wrapOptionSelected = this.querySelector('[data-custom-select-wrap-option-selected]');

		this.selectors = {
			optionLabel: "[data-custom-select-option-label]"
		}

		if (!this.classList.contains('one-table')) {
			this.init();
			this.setOptionSelected();
		}

		const eventFocusTableSelectInit = new Event('focus-table-select-init');
		document.dispatchEvent(eventFocusTableSelectInit);
	}

	init() {

		if (this.triggers.length > 0) {

			// === On click in
			this.triggers.forEach(trigger => {
				trigger.addEventListener('click', (e) => {

					let allowProcess = true;

					// === Check if input disabled
					if (trigger.tagName == 'LABEL') {
						const thisInput = document.getElementById(trigger.getAttribute('for'));
						if (thisInput !== null && thisInput !== undefined && thisInput.disabled) {
							allowProcess = false;
						}
					}

					if (allowProcess) {
						// === Open & Close
						if (this.classList.contains('active')) {
							this.style.removeProperty('height');
						} else {
							this.style.height = this.offsetHeight + 'px';
						}
						this.classList.toggle('active');


						// === Active selected option

						const selectedOption = trigger.closest('[data-custom-select-option]');

						if (this.options.length > 0 && selectedOption !== null && selectedOption !== undefined) {
							this.options.forEach(option => {
								if (option !== selectedOption) {
									option.classList.remove('active');
								} else {
									option.classList.add('active');
								}
							});
						}

						this.setOptionSelected();

					}

				});
			});

			// === On click out
			document.addEventListener('click', (e) => {

				if (this.classList.contains('active')) {

					let closeThisCustomSelect = true;
					const targetCustomSelectParent = e.target.closest('composition-block-table-select');
					if (targetCustomSelectParent !== null && targetCustomSelectParent !== undefined && targetCustomSelectParent === this) {
						closeThisCustomSelect = false;
					}

					if (closeThisCustomSelect) {
						this.classList.remove('active');
					}

				}

			});

		}

	}

	setOptionSelected() {

		if (this.options.length > 0 && this.optionSelected !== null && this.optionSelected !== undefined) {
			this.options.forEach(option => {
				if (option.classList.contains('active')) {

					// Set label
					const selectedOptionLabel = option.querySelector(this.selectors.optionLabel);
					if (selectedOptionLabel !== null && selectedOptionLabel !== undefined) {
						this.optionSelected.innerHTML = selectedOptionLabel.innerHTML;
					}

					// Show selected table columns
					const selectedTableRef = option.getAttribute('data-custom-select-option');
					if (selectedTableRef !== null && selectedTableRef !== undefined) {
						const allTableTds = document.querySelectorAll(`[data-block-id="${this.dataset.blockId}"] [data-composition-table-td-ref]`);
						if (allTableTds.length > 0) {
							allTableTds.forEach(td => {
								td.classList.toggle('hide', td.getAttribute('data-composition-table-td-ref') != selectedTableRef);
							});
						}
					}

				}
			});
		}

	}
}

customElements.get('composition-block-table-select') || customElements.define('composition-block-table-select', CompositionBlockTableSelect)
